<template>
  <!--支付方式--->
  <el-select v-model="paymentWayCode" clearable>
    <el-option
      v-for="item in paymentWayList"
      :key="item.dictCode"
      :label="item.dictName"
      :value="item.dictCode">
    </el-option>
  </el-select>
  <!------------->
</template>

<script>
  import {getListByTypeCodeAndPCode} from '@/api/dict/dic_manage'

  export default {
    name: "select-paymentWay",
    data() {
      return {
        paymentWayList: [],
        paymentWayCode: ''
      }
    },
    created() {
      let data = {
        dictTypeCode: 'PAYMENT_WAY',
        parentCode: -1,
      }
      getListByTypeCodeAndPCode(data).then(res => {
        if (res.code == 1) {
          this.paymentWayList = res.data
        }
      })
    },
    watch: {
      paymentWayCode: function (currentVal) {
        this.$emit('paymentWayInfo', {paymentWayCode: currentVal})
      }
    }
  }
</script>

<style scoped>

</style>
